import { AppBar, useTheme, Toolbar, IconButton, Box, Typography } from '@mui/material';
import { Menu02 } from '../../../../assets';
import { useContext } from 'react';
import { DrawerContext, DrawerValues } from '../contexts/DrawerContext';
import { UserContext } from '../../../shared/useUser';
import { useNavigate } from 'react-router-dom';

export const DrawerMobileAppBar = () => {
  const theme = useTheme();
  const { setOpen, open, isMobile } = useContext(DrawerContext) as DrawerValues;
  const { selectedSystem } = useContext(UserContext);
  const navigate = useNavigate();

  if (!isMobile) return <></>;

  return (
    <AppBar sx={{
      height: '56px',
      maxHeight: '56px',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      px: 6,
    }}>
      <Box display='flex'
        alignItems='center'
        justifyContent='flex-start'
        sx={{
          width: '100%',
          height: '100%',
          position: 'relative',
        }}
        onClick={() => navigate('/')}>
        <img alt='logo'
          src={'/logo-reverse.svg'}
          height='26px' />
        <Typography
          fontSize='16px'
          fontWeight={600}
          color={theme.palette.primary.contrastText}
          sx={{
            paddingLeft: '6px',
            paddingBottom: '0',
            marginBottom: '-4px',
          }}>
          {selectedSystem?.name?.replace('Orderly ', '')}
        </Typography>
      </Box>
      <Toolbar sx={{ justifyContent: 'flex-end' }}>
        <IconButton
          size="large"
          aria-label="menu"
          edge="end"
          sx={{
            mr: 2,
            color: 'common.white',
          }}
          onClick={() => setOpen(!open)}
        >
          <Menu02 />
        </IconButton>
      </Toolbar>
    </AppBar >);
};